import {useMutation, useQueryClient} from "@tanstack/react-query";
import {updateAccountInfoApi} from "../../../../../api/correspondent/CorresspondentApi";
import {BasicClientInfoType} from "../interface";
import {useModal} from "../../../../../hooks";
import useGoToNavigation from "../../../../../util/useGotoNavigation";

type Props = {
    setRead: () => void;
    isCreate: boolean;
    isFileManaged?: boolean;
};

export const useUpdateAccountInfo = ({setRead, isCreate, isFileManaged}: Props) => {
    const queryClient = useQueryClient();
    const {handleModal} = useModal();
    const {goToNavigation} = useGoToNavigation();

    const {mutate} = useMutation({
        mutationFn: (data: BasicClientInfoType) => updateAccountInfoApi(data),
        onSuccess: (res) => {
            if (isCreate) {
                setRead();
                console.log(res?.result);

                handleModal({
                    isOpen: true,
                    contents: "저장되었습니다.",
                    type: "alert",
                    closeAction: () => goToNavigation(
                        `customer/correspondent/detail/${res?.result?.accountId}`,
                        {
                            customerCategoryName: res?.result?.customerCategoryName,
                            accountId: res?.result?.accountId,
                            name: res?.result?.name,
                            industryName: res?.result?.industryName,
                            chargeName: res?.result?.chargeName,
                            defaultContact: res?.result?.defaultContact,
                        },
                        false
                    )
                });
            } else {
                handleModal({
                    isOpen: true,
                    contents: res?.msg,
                    type: "alert",
                });
                setRead();
                queryClient.invalidateQueries({
                    queryKey: ["readAccountBasicInfo"],
                });
            }
        },
        onError: (error: any) => {
            console.log("update error", error);
            console.log("isFileManaged, error message : ", isFileManaged, error?.response.data.msg);
            handleModal({
                isOpen: true,
                contents: !isFileManaged ? error?.response.data.msg : error?.response.data.msg,
                type: "alert",
            });
        },
    });

    return {mutate};
};
